import { useLoaderData } from "@remix-run/react";
// import { marked } from "marked";
import invariant from "tiny-invariant";
import apiClient from "~/api/axios.server";
import { ArticleDescriptionLayout, ArticleTabs } from "~/screens";
import type { ArticleData } from "~/types";
import type { LinksFunction, V2_MetaFunction } from "@remix-run/node";
// import { json} from  "@remix-run/node";
import articlegallerystyle from "~/screens/articles/style/article_image.css";
import config from "~/config.server";

export const links: LinksFunction = () => {
  return [{ rel: "stylesheet", href: articlegallerystyle }];
};

export const loader = async ({ request, params }: any) => {
  invariant(params.articleId, `params.articleId is required`);
  // const start = Date.now();
  // console.log("============start params.articleId", start, params.articleId);
  const cliend = apiClient();
  const { articleId } = params;

  try {
    const response = await cliend.get<ArticleData>(
      `/media/${Number(articleId)}`
    );
    // console.log("article data responze", response);
    const { data } = response;
    // const secSpent = (Date.now() - start) / 1000;
    // console.log("============response params.articleId", secSpent);
    return {
      ...data,
      baseUrl: config.BASEURL
    };
  } catch (error: any) {
    throw new Error(String(error.response.data.message));
  }
};
export const meta: V2_MetaFunction<typeof loader> = ({ data }) => {
  if (!data) return [];
  const { metaInfo } = data;
  // console.log("dalhsdladataaaa", config);
  return [
  { title: metaInfo.title },
  {
    property: "og:title",
    content: metaInfo.ogTitle
  },
  {
    property: "og:url",
    content: metaInfo.canonical
  },
  { property: "og:description", content: metaInfo.ogDescription },
  { property: "og:image", content: `${data.baseUrl}/${metaInfo.ogImage}` },
  {
    name: "description",
    content: metaInfo.description
  }];

};

export default function ArticleDetail() {
  // const { articleId, articleName } = useParams();
  const data = useLoaderData<ArticleData>();
  // console.log("data", data);

  return (
    <div className="section-wrapper">
      <ArticleDescriptionLayout {...data} />
      {/* <div className="h-96 border-red-500">
         <Accordionlayout />
        </div> */}
      <ArticleTabs {...data} />
    </div>);

}